import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../../../../components/shared/Loading";
import PageContainer from "../../../../../components/template/PageContainer";
import { validateAdminParams } from "../../../../../router/admin-validation";
import { requireRoles } from "../../../../../router/auth";
import type { RouteMetadata } from "../../../../../router/metadata";
import { parseProjectSearch } from "../../../../../router/route-contracts";

const Screen = lazy(() => import("../../../../../views/projects/Project"));

export const Route = createFileRoute(
  "/_protected/(admin)/projects/$projectId/$companyId",
)({
  component: RouteComponent,
  validateSearch: parseProjectSearch,
  beforeLoad: ({ context }) => requireRoles(context.authSnapshot, ["Admin"]),
  params: { parse: validateAdminParams },
  staticData: {
    routeKey: "projects-admin",
    access: "admin",
    layout: "modern",
    container: "default",
    footer: false,
    requiredRoles: ["Admin"],
  } satisfies RouteMetadata,
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
